// DiscountCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Persentase Diskon";
const DESCRIPTION =
  "Hitung jumlah diskon dan harga akhir setelah menerapkan persentase diskon pada harga total. Kalkulator ini menyediakan cara mudah dan cepat untuk mengetahui jumlah diskon dan uang yang akan Anda hemat.";
const KEYWORDS = "kalkulator, diskon, persentase, hemat, harga";
const OG_URL = "https://do-calculate.com/calculator/id/discount-calculator/";
function DiscountCalculator() {
  const [totalPrice, setTotalPrice] = useState("0");
  const [discountPercentage, setDiscountPercentage] = useState("0");
  const [discountAmount, setDiscountAmount] = useState(null);
  const [finalPrice, setFinalPrice] = useState(null);
  const [error, setError] = useState("");
  const calculateDiscount = () => {
    try {
      if (totalPrice === "0" && discountPercentage === "0") {
        setError("Harap masukkan nilai untuk menghitung persentase");
        return;
      }
      const discount = (totalPrice * discountPercentage) / 100;
      const final = totalPrice - discount;
      setDiscountAmount(discount);
      setFinalPrice(final);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara sederhana untuk menghitung diskon dan harga akhir setelah menerapkan persentase diskon pada harga total. Dengan kalkulator ini, Anda dapat dengan mudah mengetahui jumlah uang yang akan Anda hemat saat membeli produk tertentu. Yang perlu Anda lakukan adalah memasukkan harga total produk dan persentase diskon, dan kalkulator akan menampilkan jumlah diskon dan harga akhir yang akan Anda bayar.
                </p>
                <p>
                  Misalnya, jika Anda memiliki produk dengan harga 100 dolar dan persentase diskon 20%, Anda dapat menggunakan kalkulator ini untuk menentukan jumlah diskon yang akan Anda dapatkan, dan juga untuk mengetahui harga akhir yang akan Anda bayar setelah menerapkan diskon. Mengetahui detail ini sebelumnya dapat membantu Anda membuat keputusan pembelian yang tepat.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="total-price">Harga Total:</label>
                    <input
                      id="total-price"
                      type="number"
                      value={totalPrice}
                      onChange={(e) => setTotalPrice(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="discount">Persentase Diskon:</label>
                    <input
                      id="discount"
                      type="number"
                      value={discountPercentage}
                      onChange={(e) => setDiscountPercentage(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">%</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateDiscount}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  discountAmount !== null &&
                  finalPrice !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Jumlah Diskon: {discountAmount.toFixed(2)}</p>
                      <p>Harga Akhir: {finalPrice.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Persentase Diskon</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Menentukan Harga Total
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda harus menentukan harga total produk yang ingin Anda hitung diskonnya. Harga total adalah harga sebelum menerapkan diskon apa pun. Harga ini dianggap sebagai dasar untuk melihat diskon yang akan diterapkan. Pastikan untuk memasukkan harga total yang benar karena ini akan langsung mempengaruhi perhitungan yang akan dilakukan selanjutnya. Setelah menentukan harga total, Anda dapat melanjutkan ke langkah berikutnya yang berkaitan dengan memasukkan persentase diskon.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Memasukkan Persentase Diskon
                    </h2>
                  </u>
                  <p>
                    Pada langkah ini, Anda harus memasukkan persentase diskon yang ingin Anda terapkan pada harga total. Persentase diskon adalah nilai persentase yang akan dikurangkan dari harga total produk. Misalnya, jika persentase diskon 20%, ini berarti Anda akan menghemat 20% dari harga total. Memasukkan persentase diskon dengan benar sangat penting untuk memastikan akurasi perhitungan akhir yang akan ditampilkan oleh kalkulator.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Menghitung Jumlah Diskon
                    </h2>
                  </u>
                  <p>
                    Setelah memasukkan harga total dan persentase diskon, Anda dapat menghitung jumlah diskon dengan mudah. Untuk melakukannya, kalikan harga total dengan persentase diskon lalu bagi hasilnya dengan 100. Perhitungan ini akan memberi Anda jumlah diskon yang akan dikurangkan dari harga total. Misalnya, jika harga total adalah 100 dolar dan persentase diskon adalah 20%, maka jumlah diskon akan menjadi 20 dolar.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika harga total 100 dolar dan persentase diskon 20%, maka jumlah diskon adalah 20 dolar.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Menentukan Harga Akhir
                    </h2>
                  </u>
                  <p>
                    Langkah terakhir adalah menentukan harga akhir yang akan Anda bayar setelah menerapkan diskon. Untuk mendapatkan harga akhir, kurangkan jumlah diskon dari harga total. Ini akan memberi Anda harga akhir yang harus Anda bayar setelah diskon. Langkah ini penting karena menunjukkan jumlah aktual yang akan Anda bayar setelah diskon, membantu Anda mengelola anggaran dengan lebih baik.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: 100 dolar - 20 dolar = 80 dolar (harga akhir).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DiscountCalculator;